export const ACROFORM_LIMITS = {
  fileBytes: 32 * 1024 * 1024,
  pages: 200,
  fields: 500,
  fieldNameChars: 256,
  valueChars: 10_000,
  totalValueChars: 250_000,
  optionsPerField: 500,
  totalOptions: 5_000,
  totalOptionChars: 250_000,
  indirectObjects: 25_000,
} as const
